/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// This file exists to easily patch the SpyNgModuleFactoryLoader into g3
export const EXTRA_ROUTER_TESTING_PROVIDERS = [];
